var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_c('b-badge',{staticClass:"mr-1 hds-filter-value-badge",class:_vm.customClass,attrs:{"pill":""}},[_vm._v(" "+_vm._s(_vm.badgeText)+" "),(_vm.isEditable)?_c('b-icon',{staticClass:"ml-1",attrs:{"icon":"x-circle"},on:{"click":_vm.onClick}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }